import { render } from "./Footer.vue?vue&type=template&id=da6e55f6&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=da6e55f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6e55f6"]])

export default __exports__